export default "__VITE_ASSET__Db19pJE9__"